// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace GoalStatusFlowStateActions {
  export class Load {
    public static readonly type = '[GoalStatusFlow] Load';
  }
}
